import { render } from "./AssocOrderTicketsDetail.vue?vue&type=template&id=c0a322f0"
import script from "./AssocOrderTicketsDetail.vue?vue&type=script&lang=js"
export * from "./AssocOrderTicketsDetail.vue?vue&type=script&lang=js"

import "./AssocOrderTicketsDetail.vue?vue&type=style&index=0&id=c0a322f0&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__